import { iotsUtils } from '@bedc/core';

import { Point } from './Point';

export const Path = iotsUtils.NonEmptyArray(Point);
